import React, { useCallback, useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
// import Modal from "react-bootstrap/Modal"; // Removed Modal import
import Row from "react-bootstrap/Row";
import { InputField } from "../../../../Components/formElements/InputField";

import ItemServiceV2 from "../../../../services/logistics_appCommonService";
import ItemService from "../../../../services/supplier_appCommonService";
import toast from "react-hot-toast";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";

//Redux
import { useSelector } from "react-redux";
import {
  getTimeFromStringInAmPm,
  getTodaysData,
  validateContactNumber,
  validateName,
  validateRequired,
  validateTextArea,
} from "../../../../common/Validations";
import { useNavigate } from "react-router-dom";
// import LogisticsConstants from "../../../../common/LogisticsConstants";
import Constants from "../../../../common/CustomerConstants";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import Layout from "../../../../Layout/Layout"; // Added Layout
import FileViewerModalForHB from "../../../../Components/FileViewer/FileViewerModalForHB";
import FileUploadComponentForHB from "../../../smart_construction_app/Customer_V4/Common/FileUploadComponentForHB";

const message = {
  VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  VALID_MAIL_ID: "Please enter a valid email address.",
  VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_ALTERNATE_CONTACT_NUMBER:
    "Please enter a valid alternate contact number.",
  VALID_PURPOSE_JUSTIFICATION:
    "Please ensure the justification is under 500 characters.",
  VALID_POSTAL_CODE:
    "Enter a 6-character postal code with uppercase letters and numbers only",
  VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  EXIStS_MAIL_ID: "Email already exists",
  EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  ALTERNATE_MAIL_ID: "Email ID is same",
  ALTERNATE_CONTACT_NUMBER: "Contact number is same",
};

// Removed forwardRef and props since it is now a standalone page
const CreateGateEntryPage = () => {
  const navigate = useNavigate();
  let userData = useSelector((state) => state?.user?.data);

  const [disabled, setDisabled] = useState(false);
  const [getDropdownData, setDropdownData] = useState("");
  // const [getCustomer, setCustomer] = useState([]);

  const [getPOList, setPOList] = useState([]);
  const [selectedPO, setSelectedPO] = useState(null);
  const [loadingPO, setLoadingPO] = useState(false);
  const [poItems, setPOItems] = useState([]);
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState("");
  useEffect(() => {
    fetchPOList("");
  }, []);

  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };
  const [getFailureModal] = useState(failureModalData);

  const [getErrorFields, setErrorFields] = useState([]);
  const [getShowFailureModal, setShowFailureModal] = useState(false);

  const nextHourOptions = [
    { id: 1, name: "1 Hours" },
    { id: 2, name: "2 Hours" },
    { id: 3, name: "3 Hours" },
    { id: 4, name: "4 Hours" },
    { id: 5, name: "5 Hours" },
    { id: 6, name: "6 Hours" },
    { id: 7, name: "7 Hours" },
    { id: 8, name: "8 Hours" },
    { id: 9, name: "9 Hours" },
    { id: 10, name: "10 Hours" },
    { id: 11, name: "11 Hours" },
    { id: 12, name: "12 Hours" },
  ];

  const [formInputs, setFormInputs] = useState({
    gateCode: "",
    purchasingDocumentNr: "",
    inDate: getTodaysData() || "",
    gateInwardSelectedTime: "",
    inNextHour: "",
    inCustomerName: "",
    inVehicleNumber: "",
    inDriverName: "",
    inDriverMobileNumber: "",
    inVehicleType: "",
    inWeightBridge: "",
    inLoadingBay: "",
    inLoadingPoints: "",
    inWeighbridgeName: "",

    gateTransportRequestNumber: "",
    outPass: "",
    gateOutWardDate: "",
    gateOutWardTime: "",
    outRemark: "",
    outNextHour: "",
    outVehicleType: "",
    outWeightBridge: "",
    outVehicleNumber: "",
    outDriverName: "",
    outDriverMobileNumber: "",
    outLoadingBay: "",
    outLoadingPoints: "",
    outWeighbridge: "",

    invoiceNumber: "",
    deliveryChallanNumber: "",
    ewayBillNumber: "",

    invoiceAttachmentId: "",
    deliveryChallanAttachmentId: "",
    ewayBillAttachmentId: "",
    module: "CUSTOMER",
  });
  useEffect(() => {
    setFormInputs({
      // createdBy: userData?.userId || "",
      inDate: getTodaysData() || "",
    });
  }, [userData]);

  //Validations
  const [validation, setValidation] = useState({
    inDriverName: "",
  });

  const handleInputChange = ({ target: { name, value } }) => {
    let error = "";

    //Inward Validation
    if (name === "inDriverName" && !validateName(value)) {
      error = message.VALID_CUSTOMER_NAME;
    }
    if (name === "inCustomerName" && !validateName(value)) {
      error = message.VALID_CUSTOMER_NAME;
    }
    if (name === "inDriverMobileNumber" && !validateContactNumber(value)) {
      error = message.VALID_CONTACT_NUMBER;
    }
    //OutWard Validations

    if (name === "gateTransportRequestNumber" && !validateRequired(value)) {
      error = message.FILL_REQUIRED_FIELD;
    }
    if (name === "outCustomerName" && !validateName(value)) {
      error = message.VALID_CUSTOMER_NAME;
    }

    if (name === "outDriverName" && !validateName(value)) {
      error = message.VALID_CUSTOMER_NAME;
    }
    if (name === "outDriverMobileNumber" && !validateContactNumber(value)) {
      error = message.VALID_CONTACT_NUMBER;
    }

    setFormInputs((prevInputs) => ({
      ...prevInputs,
      [name]: value,
    }));

    setValidation((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  const timeOptions = [];

  let id = 1;
  for (let hour = 6; hour <= 24; hour++) {
    for (let min = 0; min < 60; min += 30) {
      const date = new Date();
      date.setHours(hour, min, 0, 0);
      const formattedTime = getTimeFromStringInAmPm(date);
      timeOptions.push({ id: id++, name: formattedTime });
    }
  }

  const gateInWardOutWard = [
    { id: 1, name: "InWard", textField: "gateInwardType" }, //red
    { id: 2, name: "OutWard", textField: "gateInwardType" }, //yellow
  ];

  const typeOfOutpass = [
    { id: 1, name: "Yes" }, //red
    { id: 2, name: "No" }, //yellow
  ];

  useEffect(() => {
    if (!getDropdownData) return;

    // console.log(">>Check getDropdownData Data", getDropdownData);

    setFormInputs((prev) => ({
      ...prev,
      [getDropdownData?.textField]: getDropdownData?.name,
    }));

    // setSelectedDropdown(getDropdownData?.textField);
  }, [getDropdownData]);

  const initialState = {
    gateCode: "",
    inDate: getTodaysData() || "",
    gateInwardSelectedTime: "",
    inNextHour: "",
    inCustomerName: "",
    inVehicleNumber: "",
    inDriverName: "",
    inDriverMobileNumber: "",
    inVehicleType: "",
    inWeightBridge: "",
    inLoadingBay: "",
    inLoadingPoints: "",
    inWeighbridge: "",

    gateTransportRequestNumber: "",
    outPass: "",
    gateOutWardDate: "",
    gateOutWardTime: "",
    outRemark: "",
    outNextHour: "",
    outVehicleType: "",
    outWeightBridge: "",
    outVehicleNumber: "",
    outDriverName: "",
    outDriverMobileNumber: "",
    outLoadingBay: "",
    outLoadingPoints: "",
    outWeighbridge: "",
    outCustomerName: "",

    invoiceNumber: "",
    deliveryChallanNumber: "",
    ewayBillNumber: "",

    invoiceAttachmentId: "",
    deliveryChallanAttachmentId: "",
    ewayBillAttachmentId: "",
  };

  // Handle Save - Simplified
  const handleSave = async () => {
    // const requiredFields = [];

    // Validation for InWard
    if (formInputs.gate === "InWard") {
      if (!validateRequired(formInputs.purchasingDocumentNr)) {
        toast.error("Please select a PO");
        return;
      }

      if (!validateRequired(formInputs.inCustomerName)) {
        toast.error("Customer name is required");
        return;
      }

      if (!validateRequired(formInputs.inVehicleNumber)) {
        toast.error("Vehicle number is required");
        return;
      }

      if (!validateRequired(formInputs.inDriverName)) {
        toast.error("Driver name is required");
        return;
      }

      if (!validateName(formInputs.inDriverName)) {
        toast.error(message.VALID_CUSTOMER_NAME);
        return;
      }

      if (
        formInputs.inDriverMobileNumber &&
        !validateContactNumber(formInputs.inDriverMobileNumber)
      ) {
        toast.error(message.VALID_CONTACT_NUMBER);
        return;
      }

      if (!validateRequired(formInputs.invoiceNumber)) {
        toast.error("Invoice Number is required", {
          duration: 3000,
          position: "top-right",
        });
        setValidation((prev) => ({
          ...prev,
          invoiceNumber: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }

      if (!validateRequired(formInputs.deliveryChallanNumber)) {
        toast.error("Delivery Challan Number is required", {
          duration: 3000,
          position: "top-right",
        });
        setValidation((prev) => ({
          ...prev,
          deliveryChallanNumber: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }

      if (!validateRequired(formInputs.ewayBillNumber)) {
        toast.error("E-way Bill Number is required", {
          duration: 3000,
          position: "top-right",
        });
        setValidation((prev) => ({
          ...prev,
          ewayBillNumber: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }

      if (formInputs.invoiceAttachmentId && !formInputs.invoiceNumber) {
        toast.error("Please enter Invoice Number", {
          duration: 3000,
          position: "top-right",
        });
        return;
      }

      if (
        formInputs.deliveryChallanAttachmentId &&
        !formInputs.deliveryChallanNumber
      ) {
        toast.error("Please enter Delivery Challan Number", {
          duration: 3000,
          position: "top-right",
        });
        return;
      }

      if (formInputs.ewayBillAttachmentId && !formInputs.ewayBillNumber) {
        toast.error("Please enter E-way Bill Number", {
          duration: 3000,
          position: "top-right",
        });
        return;
      }
    }

    // Validation for OutWard
    if (formInputs.gate === "OutWard") {
      const requiredFields = []; // Locally defined for outward logic
      if (!validateRequired(formInputs.gateTransportRequestNumber)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          gateTransportRequestNumber: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
      if (!validateRequired(formInputs.outDriverName)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          inDriverName: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }

      if (!validateName(formInputs.outDriverName)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          inDriverName: message.VALID_CUSTOMER_NAME,
        }));
        return;
      }
      if (!validateTextArea(formInputs.outRemark)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          outRemark: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }

      if (!validateRequired(formInputs.outVehicleNumber)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          outVehicleNumber: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
      if (!validateRequired(formInputs.outDriverName)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          outDriverName: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }

      if (!validateName(formInputs.outDriverName)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          outDriverName: message.VALID_CUSTOMER_NAME,
        }));
        return;
      }
      if (!validateContactNumber(formInputs.outDriverMobileNumber)) {
        requiredFields.push(`${message.VALID_CONTACT_NUMBER}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          outDriverMobileNumber: message.VALID_CONTACT_NUMBER,
        }));
        return;
      }
      if (!validateRequired(formInputs.outLoadingBay)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          outLoadingBay: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
      if (!validateRequired(formInputs.outLoadingPoints)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          outLoadingPoints: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
      if (!validateRequired(formInputs.outWeighbridge)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          outWeighbridge: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
    }

    const payload = {
      data: {
        ...formInputs,
        purchasingDocumentNr: formInputs.purchasingDocumentNr,
      },
    };
    setDisabled(true);

    try {
      const item = await ItemServiceV2.addGateEntry(payload);
      if (item?.status === 200) {
        toast.success(item?.message || "Gate entry created successfully", {
          duration: 2000,
          position: "top-right",
        });
        setFormInputs({ ...initialState });
        setSelectedPO(null);
        setPOItems([]);
        setPOList([]);
        setValidation({});
        navigate(Constants.CUST_GATE_ENTRY_LIST);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (error) {
      console.error("Save Error:", error);
      toast.error("Failed to save gate entry. Please try again!", {
        duration: 4000,
        position: "top-right",
      });
    } finally {
      setDisabled(false);
    }
  };

  // Handle Cancel
  const handleCancel = () => {
    setFormInputs({ ...initialState });
    setSelectedPO(null);
    setPOItems([]);
    setValidation({});
    navigate(-1); // Go back instead of onHide
  };

  // Hide Failure Modal
  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  // Fetch PO List
  const fetchPOList = async (searchTerm = "") => {
    setLoadingPO(true);

    try {
      let obj = {
        module: "PO",
        queryName: "getMaterialPO",
        page: 1,
        per_page: 99999,
        searchTerm: searchTerm,
        rowFilter: {
          $and: [
            {
              statusHeader: {
                $in: ["PO Approved", "New"],
              },
            },
          ],
        },
      };

      const response = await ItemService.getPurchaseOrder(obj);

      if (response?.status === 200 && response?.data) {
        const formattedData = response.data.map((po) => ({
          id: po.purchasingDocumentNr || po.documentNumber,
          name: po.purchasingDocumentNr || po.documentNumber,
          vendorName: po.vendorName || "",
          vendorCode: po.vendorCode || "",
          items: po.items || [],
          fullData: po,
        }));

        setPOList(formattedData);
      } else {
        setPOList([]);
        toast.error("Unable to fetch PO list", {
          duration: 3000,
          position: "top-right",
        });
      }
    } catch (error) {
      console.error("Error fetching PO:", error);
      setPOList([]);
      toast.error("Error fetching PO data", {
        duration: 3000,
        position: "top-right",
      });
    } finally {
      setLoadingPO(false);
    }
  };

  // Clear PO data when Gate type changes
  useEffect(() => {
    if (formInputs.gate !== "InWard") {
      setSelectedPO(null);
      setPOItems([]);
      setFormInputs((prev) => ({
        ...prev,
        purchasingDocumentNr: "",
        inCustomerName: "",
      }));
    }
  }, [formInputs.gate]);

  // Handle Generic Dropdown Change (Gate, Hours, etc.)
  const handleDropdownChange = useCallback((dropdownData) => {
    if (!dropdownData) return;

    setFormInputs((prev) => ({
      ...prev,
      [dropdownData?.textField]: dropdownData?.name,
    }));
  }, []);

  // Handle PO Selection
  const handlePOSelection = useCallback(
    (selectedData) => {
      console.log("PO Selected:", selectedData);

      if (!selectedData || !selectedData.name) {
        setSelectedPO(null);
        setPOItems([]);
        setFormInputs((prev) => ({
          ...prev,
          purchasingDocumentNr: "",
          inCustomerName: "",
        }));
        return;
      }

      if (formInputs.gate === "InWard") {
        setSelectedPO(selectedData);

        // Auto-fill customer name from vendor
        setFormInputs((prev) => ({
          ...prev,
          purchasingDocumentNr: selectedData.name,
          inCustomerName: selectedData.vendorName || "",
        }));

        // Set PO items for display
        setPOItems(selectedData.items || []);
      }
    },
    [formInputs.gate],
  );

  // File Upload Handlers
  const handleInvoiceUpload = (response) => {
    console.log("Invoice Upload Response:", response);

    if (response?.attachmentId) {
      setFormInputs((prev) => ({
        ...prev,
        invoiceAttachmentId: response.attachmentId,
      }));

      toast.success(response?.message || "Invoice uploaded successfully", {
        duration: 2000,
        position: "top-right",
      });
    } else {
      toast.error("Invoice upload failed", {
        duration: 3000,
        position: "top-right",
      });
    }
  };

  const handleDeliveryChallanUpload = (response) => {
    if (response?.attachmentId) {
      setFormInputs((prev) => ({
        ...prev,
        deliveryChallanAttachmentId: response.attachmentId,
      }));

      toast.success("Delivery Challan uploaded successfully", {
        duration: 2000,
        position: "top-right",
      });
    }
  };

  const handleEwayBillUpload = (response) => {
    if (response?.attachmentId) {
      setFormInputs((prev) => ({
        ...prev,
        ewayBillAttachmentId: response.attachmentId,
      }));

      toast.success("E-way Bill uploaded successfully", {
        duration: 2000,
        position: "top-right",
      });
    }
  };

  // File Viewer Handlers
  const handleViewFile = (fileAttachmentId) => {
    if (fileAttachmentId) {
      setFileViewData(fileAttachmentId);
      setShowFileViewModal(true);
    } else {
      toast.error("No file to view", {
        duration: 2000,
        position: "top-right",
      });
    }
  };

  const handleViewFileHide = () => {
    setShowFileViewModal(false);
    setFileViewData("");
  };

  const handleAttachmentDeleted = ({
    attachmentId,
    hasFiles,
    remainingCount,
  }) => {
    if (hasFiles && remainingCount === 0) {
      setFormInputs((prev) => ({
        ...prev,
        invoiceAttachmentId: "",
        deliveryChallanAttachmentId: "",
        ewayBillAttachmentId: "",
      }));
    }
  };

  useEffect(() => {
    if (getDropdownData?.textCode === "customerCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
      }));

      //   setCustomerID(getDropdownData?.id);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  return (
    <main className="dashboard main sri-venkateshwara" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Gate Entry Registration</h2>
            <p className="subText">Register Inward/Outward movements</p>
            <hr />

            <div className="accordion mb-4">
              <div className="accordion-item shadow-sm">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">GI</span>
                    </Col>
                    <Col xs={11} md={11} lg={11}>
                      <span className="headerTitle">
                        Gate Entry - Inward/Outward
                      </span>
                      <span className="subHeaderTitle">Gate Entry Details</span>
                    </Col>
                  </Row>
                </h2>

                <div className="accordion-body">
                  <Row className="pt-2 pb-4">
                    {/* Gate Selection */}
                    <Col xs={12} md={6} lg={4} className="commLeftRightPadding">
                      <ComboboxField
                        // label="Gate"
                        label={
                          <>
                            <i className="bi bi-door-open labelIcon"></i>
                            Gate
                          </>
                        }
                        placeholder="Select"
                        data={gateInWardOutWard}
                        id="gate"
                        name="gate"
                        code="gateCode"
                        description="gateDesc"
                        setValue={formInputs.gate || ""}
                        getvalue={handleDropdownChange}
                        required={true}
                      />
                    </Col>

                    {/* InWard Fields */}
                    {formInputs.gate === "InWard" && (
                      <>
                        {/* PO Selection */}
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            // label="PO Number"
                            label={
                              <>
                                <i className="bi bi-file-earmark-text labelIcon"></i>
                                PO Number
                              </>
                            }
                            placeholder="Search and select PO"
                            data={getPOList}
                            id="purchasingDocumentNr"
                            name="purchasingDocumentNr"
                            code="purchaseOrderCode"
                            description="vendorName"
                            setValue={formInputs.purchasingDocumentNr || ""}
                            getvalue={handlePOSelection}
                            // required={true}
                            disabled={loadingPO}
                            error={validation.purchasingDocumentNr || ""}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Work Order Number"
                            label={
                              <>
                                <i className="bi bi-tools labelIcon"></i>
                                Work Order Number
                              </>
                            }
                            placeholder=""
                            name="inWorkOrderNumber"
                            id="inWorkOrderNumber"
                            error={validation.inWorkOrderNumber || ""}
                            value={formInputs.inWorkOrderNumber || ""}
                            onChange={handleInputChange}
                            // required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Sales Order Number"
                            label={
                              <>
                                <i className="bi bi-receipt labelIcon"></i>
                                Sales Order Number
                              </>
                            }
                            placeholder=""
                            name="inSalesOrderNumber"
                            id="inSalesOrderNumber"
                            error={validation.inSalesOrderNumber || ""}
                            value={formInputs.inSalesOrderNumber || ""}
                            onChange={handleInputChange}
                            // required={true}
                          />
                        </Col>
                        {/* Date */}
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            type="date"
                            // label="Select Date"
                            label={
                              <>
                                <i className="bi bi-calendar-date labelIcon"></i>
                                Select Date
                              </>
                            }
                            name="inDate"
                            id="inDate"
                            value={formInputs?.inDate || ""}
                            onChange={handleInputChange}
                            required={true}
                          />
                        </Col>

                        {/* Time */}
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            type="time"
                            // label="Select Time"
                            label={
                              <>
                                <i className="bi bi-clock labelIcon"></i>
                                Select Time
                              </>
                            }
                            name="gateInwardSelectedTime"
                            id="gateInwardSelectedTime"
                            value={formInputs?.gateInwardSelectedTime || ""}
                            onChange={handleInputChange}
                            required={true}
                          />
                        </Col>

                        {/* Valid for Next */}
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            // label="Valid for Next"
                            label={
                              <>
                                <i className="bi bi-hourglass-split labelIcon"></i>
                                Valid for Next
                              </>
                            }
                            placeholder=""
                            data={nextHourOptions}
                            id="inNextHour"
                            name="inNextHour"
                            code="inNextHourCode"
                            description="inNextHourDesc"
                            setValue={formInputs.inNextHour || ""}
                            getvalue={handleDropdownChange}
                          />
                        </Col>

                        {/* Customer Name */}
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Customer Name"
                            label={
                              <>
                                <i className="bi bi-person labelIcon"></i>
                                Customer Name
                              </>
                            }
                            placeholder=""
                            name="inCustomerName"
                            id="inCustomerName"
                            error={validation?.inCustomerName || ""}
                            value={formInputs?.inCustomerName || ""}
                            onChange={handleInputChange}
                            required={true}
                          />
                        </Col>

                        {/* Vehicle Number */}
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Enter Vehicle Number"

                            label={
                              <>
                                <i className="bi bi-truck labelIcon"></i>
                                Enter Vehicle Number
                              </>
                            }
                            placeholder=""
                            name="inVehicleNumber"
                            id="inVehicleNumber"
                            error={validation.inVehicleNumber || ""}
                            value={formInputs.inVehicleNumber || ""}
                            onChange={handleInputChange}
                            required={true}
                          />
                        </Col>

                        {/* Driver Name */}
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Enter Driver Name"
                            label={
                              <>
                                <i className="bi bi-person-badge labelIcon"></i>
                                Enter Driver Name
                              </>
                            }
                            placeholder=""
                            name="inDriverName"
                            id="inDriverName"
                            error={validation?.inDriverName || ""}
                            value={formInputs?.inDriverName || ""}
                            onChange={handleInputChange}
                            required={true}
                          />
                        </Col>

                        {/* Driver Mobile */}
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Enter Driver Contact Number"
                            label={
                              <>
                                <i className="bi bi-telephone labelIcon"></i>
                                Enter Driver Contact Number
                              </>
                            }
                            placeholder=""
                            name="inDriverMobileNumber"
                            id="inDriverMobileNumber"
                            error={validation.inDriverMobileNumber || ""}
                            value={formInputs.inDriverMobileNumber || ""}
                            onChange={handleInputChange}
                          />
                        </Col>

                        {/* Vehicle Type */}
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <p>
                            <strong>Please Select Vehicle type</strong>
                          </p>
                          <div className="d-flex fs-5 fw-medium ms-3 my-3">
                            <div className="d-flex align-items-center me-3">
                              <div className="form-check">
                                <input
                                  className="form-check-input me-2"
                                  type="radio"
                                  name="inVehicleType"
                                  value="emptyVehicle"
                                  checked={
                                    formInputs.inVehicleType === "emptyVehicle"
                                  }
                                  onChange={handleInputChange}
                                  id="emptyVehicle"
                                />
                                <label
                                  className="form-check-label fs-5"
                                  htmlFor="emptyVehicle"
                                >
                                  Empty Vehicle
                                </label>
                              </div>
                            </div>
                            <div className="d-flex align-items-center me-3">
                              <div className="form-check">
                                <input
                                  className="form-check-input me-2"
                                  type="radio"
                                  name="inVehicleType"
                                  value="loadedVehicle"
                                  checked={
                                    formInputs.inVehicleType === "loadedVehicle"
                                  }
                                  onChange={handleInputChange}
                                  id="loadedVehicle"
                                />
                                <label
                                  className="form-check-label fs-5"
                                  htmlFor="loadedVehicle"
                                >
                                  Loaded Vehicle
                                </label>
                              </div>
                            </div>
                          </div>
                        </Col>

                        {/* Loading Bay */}
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Loading Bay"

                            label={
                              <>
                                <i className="bi bi-box-seam labelIcon"></i>
                                Loading Bay
                              </>
                            }
                            placeholder=""
                            name="inLoadingBay"
                            id="inLoadingBay"
                            error={validation.inLoadingBay || ""}
                            value={formInputs.inLoadingBay || ""}
                            onChange={handleInputChange}
                          />
                        </Col>

                        {/* Loading Points */}
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Loading Points"
                            label={
                              <>
                                <i className="bi bi-geo-alt labelIcon"></i>
                                Loading Points
                              </>
                            }
                            placeholder=""
                            name="inLoadingPoints"
                            id="inLoadingPoints"
                            error={validation.inLoadingPoints || ""}
                            value={formInputs.inLoadingPoints || ""}
                            onChange={handleInputChange}
                          />
                        </Col>
                      </>
                    )}

                    {/* OutWard Section */}
                    {formInputs.gate === "OutWard" && (
                      <>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Transport Request Number"
                            label={
  <>
    <i className="bi bi-truck labelIcon"></i>
    Transport Request Number
  </>
}
                            placeholder=""
                            name="gateTransportRequestNumber"
                            id="gateTransportRequestNumber"
                            error={validation.gateTransportRequestNumber || ""}
                            value={formInputs.gateTransportRequestNumber || ""}
                            onChange={handleInputChange}
                            required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Customer Name"
                            label={
                              <>
                                <i className="bi bi-person labelIcon"></i>
                                Customer Name
                              </>
                            }
                            placeholder=""
                            name="outCustomerName"
                            id="outCustomerName"
                            error={validation?.outCustomerName || ""}
                            value={formInputs?.outCustomerName || ""}
                            onChange={handleInputChange}
                            required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Work Order Number"
                            label={
                              <>
                                <i className="bi bi-tools labelIcon"></i>
                                Work Order Number
                              </>
                            }
                            placeholder=""
                            name="outWorkOrderNumber"
                            id="outWorkOrderNumber"
                            error={validation.outWorkOrderNumber || ""}
                            value={formInputs.outWorkOrderNumber || ""}
                            onChange={handleInputChange}
                            // required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Sales Order Number"
                            label={
                              <>
                                <i className="bi bi-receipt labelIcon"></i>
                                Sales Order Number
                              </>
                            }
                            placeholder=""
                            name="outSalesOrderNumber"
                            id="outSalesOrderNumber"
                            error={validation.outSalesOrderNumber || ""}
                            value={formInputs.outSalesOrderNumber || ""}
                            onChange={handleInputChange}
                            // required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            label="Type Of Outpass"
                            placeholder=""
                            data={typeOfOutpass}
                            id="outPass"
                            iconClassName="dropdownIcon"
                            name="outPass"
                            code="outPass"
                            description="outPass"
                            setValue={formInputs.outPass || ""}
                            getvalue={setDropdownData}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            type="date"
                            // label="Select Date"
                            label={
                              <>
                                <i className="bi bi-calendar-date labelIcon"></i>
                                Select Date
                              </>
                            }
                            name="outDate"
                            id="outDate"
                            value={formInputs?.outDate}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            type="time"
                            // label="Select Time"
                            label={
                              <>
                                <i className="bi bi-clock labelIcon"></i>
                                Select Time
                              </>
                            }
                            name="gateOutWardTime"
                            id="gateOutWardTime"
                            value={formInputs?.gateOutWardTime}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Enter Vehicle Number"
                            label={
                              <>
                                <i className="bi bi-truck labelIcon"></i>
                                Enter Vehicle Number
                              </>
                            }
                            placeholder=""
                            name="outVehicleNumber"
                            id="outVehicleNumber"
                            error={validation.outVehicleNumber || ""}
                            value={formInputs.outVehicleNumber || ""}
                            onChange={handleInputChange}
                            required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Enter Driver Name"

                            label={
                              <>
                                <i className="bi bi-person-badge labelIcon"></i>
                                Enter Driver Name
                              </>
                            }
                            placeholder=""
                            name="outDriverName"
                            id="outDriverName"
                            error={validation.outDriverName || ""}
                            value={formInputs?.outDriverName || ""}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Enter Driver Contact Nr"
                            label={
                              <>
                                <i className="bi bi-telephone labelIcon"></i>
                                Enter Driver Contact Number
                              </>
                            }
                            placeholder=""
                            name="outDriverMobileNumber"
                            id="outDriverMobileNumber"
                            error={validation.outDriverMobileNumber || ""}
                            value={formInputs?.outDriverMobileNumber || ""}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Loading Bay"
                            label={
                              <>
                                <i className="bi bi-box-seam labelIcon"></i>
                                Loading Bay
                              </>
                            }
                            placeholder=""
                            name="outLoadingBay"
                            id="outLoadingBay"
                            error={validation.outLoadingBay || ""}
                            value={formInputs?.outLoadingBay || ""}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Loading Points"
                            label={
                              <>
                                <i className="bi bi-geo-alt labelIcon"></i>
                                Loading Points
                              </>
                            }
                            placeholder=""
                            name="outLoadingPoints"
                            id="outLoadingPoints"
                            error={validation.outLoadingPoints || ""}
                            value={formInputs?.outLoadingPoints || ""}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Weighbridge"
                            label={
  <>
    <i className="bi bi-speedometer2 labelIcon"></i>
    Weighbridge
  </>
}
                            placeholder=""
                            name="outWeighbridge"
                            id="outWeighbridge"
                            error={validation.outWeighbridge || ""}
                            value={formInputs?.outWeighbridge || ""}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <TextAreaField
                            className="inputBox"
                            // label="Enter Gate Remarks"
                            label={
  <>
    <i className="bi bi-chat-left-text labelIcon"></i>
    Remarks
  </>
}
                            name="outRemark"
                            id="outRemark"
                            value={formInputs.outRemark}
                            error={validation.outRemark || ""}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            // label="Valid for Next"
                            
label={
  <>
    <i className="bi bi-hourglass-split labelIcon"></i>
    Valid for Next
  </>
}
                            placeholder="Choose Hours"
                            data={nextHourOptions}
                            id="outNextHour"
                            iconClassName="dropdownIcon"
                            name="outNextHour"
                            code="outNextHour"
                            description="outNextHour"
                            setValue={formInputs.outNextHour || ""}
                            getvalue={setDropdownData}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <p>
                            <strong>Please Select Vehicle type</strong>
                          </p>
                          <div className="d-flex fs-5 fw-medium ms-3 my-3">
                            <div className="d-flex align-items-center me-3">
                              <div className="form-check">
                                <input
                                  className="form-check-input me-2"
                                  type="radio"
                                  name="outVehicleType"
                                  value="emptyVehicle"
                                  checked={
                                    formInputs.outVehicleType === "emptyVehicle"
                                  }
                                  onChange={handleInputChange}
                                  id="emptyVehicleOut"
                                />
                                <label
                                  className="form-check-label fs-5"
                                  htmlFor="emptyVehicleOut"
                                >
                                  Empty Vehicle
                                </label>
                              </div>
                            </div>

                            <div className="d-flex align-items-center me-3">
                              <div className="form-check">
                                <input
                                  className="form-check-input me-2"
                                  type="radio"
                                  name="outVehicleType"
                                  value="loadedVehicle"
                                  checked={
                                    formInputs.outVehicleType ===
                                    "loadedVehicle"
                                  }
                                  onChange={handleInputChange}
                                  id="loadedVehicleOut"
                                />
                                <label
                                  className="form-check-label fs-5"
                                  htmlFor="loadedVehicleOut"
                                >
                                  Loaded Vehicle
                                </label>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </>
                    )}
                  </Row>

                  {/* PO Items Table */}
                  {formInputs.gate === "InWard" &&
                    selectedPO &&
                    poItems.length > 0 && (
                      <Row className="mt-4 mb-3 px-2">
                        <Col xs={12}>
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <h6 className="mb-0 fw-bold text-gray-900">
                              Purchase Order Items -{" "}
                              {formInputs.purchasingDocumentNr}
                            </h6>
                          </div>

                          <div className="table-responsive">
                            <table className="table table-bordered table-hover mb-0">
                              <thead className="table-light">
                                <tr>
                                  <th
                                    className="text-center"
                                    style={{ width: "80px" }}
                                  >
                                    Item #
                                  </th>
                                  <th
                                    className="text-center"
                                    style={{ width: "150px" }}
                                  >
                                    Material Code
                                  </th>
                                  <th>Material Description</th>
                                  <th
                                    className="text-center"
                                    style={{ width: "100px" }}
                                  >
                                    Quantity
                                  </th>
                                  <th
                                    className="text-center"
                                    style={{ width: "90px" }}
                                  >
                                    UOM
                                  </th>
                                  <th style={{ width: "200px" }}>
                                    Storage Location
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {poItems.map((item, index) => (
                                  <tr key={index}>
                                    <td className="text-center">
                                      {item.purchasingDocumentItemNr ||
                                        item.local_id ||
                                        "-"}
                                    </td>
                                    <td className="text-center">
                                      <span className="text-dark">
                                        {item.materialCode || "-"}
                                      </span>
                                    </td>
                                    <td>{item.materialDescription || "-"}</td>
                                    <td className="text-center fw-bold">
                                      {item.purchaseQuantity || "0"}
                                    </td>
                                    <td className="text-center">
                                      {item.orderUnitOfMeasure || "-"}
                                    </td>
                                    <td>{item.storageLocation || "-"}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </Col>
                      </Row>
                    )}

                  {/* File Upload Section with Document Numbers */}
                  {formInputs.gate === "InWard" && (
                    <>
                      <Row className="mt-4 px-2">
                        <Col xs={12}>
                          <hr />
                          <h6 className="mb-3 fw-bold text-gray-900">
                            <i className="bi bi-file-earmark-arrow-up me-2"></i>
                            Document Details & Attachments
                          </h6>
                        </Col>
                      </Row>

                      <Row className="mb-3 px-2">
                        {/* INVOICE */}
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commLeftRightPadding mb-3"
                        >
                          <div className="mb-3">
                            <InputField
                              className="inputBox"
                              // label="Invoice Number"
                              label={
                                <>
                                  <i className="bi bi-receipt labelIcon"></i>
                                  Invoice Number
                                </>
                              }
                              placeholder="Enter invoice number"
                              name="invoiceNumber"
                              id="invoiceNumber"
                              value={formInputs.invoiceNumber || ""}
                              onChange={handleInputChange}
                              required={true}
                              error={validation.invoiceNumber || ""}
                            />
                          </div>

                          <div className="d-flex align-items-start">
                            <div style={{ flex: 1 }}>
                              <FileUploadComponentForHB
                                // label="Invoice Attachment"
                                label={
                                  <>
                                    <i className="bi bi-paperclip labelIcon"></i>
                                    Invoice Attachment
                                  </>
                                }
                                name="invoice"
                                id="invoiceUpload"
                                value={formInputs.invoiceAttachmentId || ""}
                                allowedTypes={[
                                  "application/pdf",
                                  "image/jpeg",
                                  "image/jpg",
                                  "image/png",
                                ]}
                                multiple={true}
                                required={false}
                                disabled={disabled}
                                onSuccessUpload={handleInvoiceUpload}
                                extraLabel="Upload invoice document"
                              />
                            </div>

                            <div className="d-flex align-items-center ps-2 pt-4 mt-1">
                              {formInputs.invoiceAttachmentId ? (
                                <i
                                  className="bi bi-paperclip fs-4 text-primary"
                                  title="View Invoice"
                                  onClick={() =>
                                    handleViewFile(
                                      formInputs.invoiceAttachmentId,
                                    )
                                  }
                                  style={{ cursor: "pointer" }}
                                ></i>
                              ) : (
                                <span className="text-muted">--</span>
                              )}
                            </div>
                          </div>
                        </Col>

                        {/* DELIVERY CHALLAN */}
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commLeftRightPadding mb-3"
                        >
                          <div className="mb-3">
                            <InputField
                              className="inputBox"
                              // label="Delivery Challan Number"
                              label={
                                <>
                                  <i className="bi bi-file-earmark-ruled labelIcon"></i>
                                  Delivery Challan Number
                                </>
                              }
                              placeholder="Enter DC number"
                              name="deliveryChallanNumber"
                              id="deliveryChallanNumber"
                              value={formInputs.deliveryChallanNumber || ""}
                              onChange={handleInputChange}
                              required={true}
                              error={validation.deliveryChallanNumber || ""}
                            />
                          </div>

                          <div className="d-flex align-items-start">
                            <div style={{ flex: 1 }}>
                              <FileUploadComponentForHB
                                // label="Delivery Challan Attachment"
                                label={
                                  <>
                                    <i className="bi bi-paperclip labelIcon"></i>
                                    Delivery Challan Attachment
                                  </>
                                }
                                name="deliveryChallan"
                                id="deliveryChallanUpload"
                                value={
                                  formInputs.deliveryChallanAttachmentId || ""
                                }
                                allowedTypes={[
                                  "application/pdf",
                                  "image/jpeg",
                                  "image/jpg",
                                  "image/png",
                                ]}
                                multiple={true}
                                required={false}
                                disabled={disabled}
                                onSuccessUpload={handleDeliveryChallanUpload}
                                extraLabel="Upload delivery challan"
                              />
                            </div>

                            <div className="d-flex align-items-center ps-2 pt-4 mt-1">
                              {formInputs.deliveryChallanAttachmentId ? (
                                <i
                                  className="bi bi-paperclip fs-4 text-primary"
                                  title="View Delivery Challan"
                                  onClick={() =>
                                    handleViewFile(
                                      formInputs.deliveryChallanAttachmentId,
                                    )
                                  }
                                  style={{ cursor: "pointer" }}
                                ></i>
                              ) : (
                                <span className="text-muted">--</span>
                              )}
                            </div>
                          </div>
                        </Col>

                        {/* E-WAY BILL */}
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commLeftRightPadding mb-3"
                        >
                          <div className="mb-3">
                            <InputField
                              className="inputBox"
                              // label="E-way Bill Number"
                              label={
                                <>
                                  <i className="bi bi-truck labelIcon"></i>
                                  E-way Bill Number
                                </>
                              }
                              placeholder="Enter e-way bill number"
                              name="ewayBillNumber"
                              id="ewayBillNumber"
                              value={formInputs.ewayBillNumber || ""}
                              onChange={handleInputChange}
                              required={true}
                              error={validation.ewayBillNumber || ""}
                            />
                          </div>

                          <div className="d-flex align-items-start">
                            <div style={{ flex: 1 }}>
                              <FileUploadComponentForHB
                                // label="E-way Bill Attachment"
                                label={
                                  <>
                                    <i className="bi bi-paperclip labelIcon"></i>
                                    E-way Bill Attachment
                                  </>
                                }
                                name="ewayBill"
                                id="ewayBillUpload"
                                value={formInputs.ewayBillAttachmentId || ""}
                                allowedTypes={[
                                  "application/pdf",
                                  "image/jpeg",
                                  "image/jpg",
                                  "image/png",
                                ]}
                                multiple={true}
                                required={false}
                                disabled={disabled}
                                onSuccessUpload={handleEwayBillUpload}
                                extraLabel="Upload e-way bill"
                              />
                            </div>

                            <div className="d-flex align-items-center ps-2 pt-4 mt-1">
                              {formInputs.ewayBillAttachmentId ? (
                                <i
                                  className="bi bi-paperclip fs-4 text-primary"
                                  title="View E-way Bill"
                                  onClick={() =>
                                    handleViewFile(
                                      formInputs.ewayBillAttachmentId,
                                    )
                                  }
                                  style={{ cursor: "pointer" }}
                                ></i>
                              ) : (
                                <span className="text-muted">--</span>
                              )}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <Row className="my-4">
              <Col
                lg={{ span: 2, offset: 8 }}
                className="d-flex justify-content-end mt-2"
              >
                <button
                  className="btnTable btn-danger text-white bg-danger"
                  onClick={handleCancel}
                  disabled={disabled}
                >
                  Cancel
                </button>
              </Col>
              <Col lg={2} className="d-flex justify-content-end mt-2">
                <button
                  className="btnTable"
                  disabled={disabled}
                  onClick={handleSave}
                >
                  {disabled ? "Saving..." : "Create"}
                </button>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      {/* Internal Modals */}
      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />

      <FileViewerModalForHB
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
        onDeleteSuccess={handleAttachmentDeleted}
      />
    </main>
  );
};

export default CreateGateEntryPage;
